import { ShopUserType } from "../types/shop";
import { AdminUserFormData } from "../types/user";
import { get, post } from "./fetch.core";

export type VerifyStatus = "failedOrNotExist" | "alreadyVerified" | "pending";

async function addUser(email: string, type: ShopUserType, name: string) {
  await post("/admin/shop/addUser", {
    email,
    type,
    name,
  });
}

export async function getShopUser(adminUserId: string) {
  const rst = await get<AdminUserFormData>(`/admin/shop/getUser?adminUserId=${adminUserId}`);
  return rst.data;
}

export async function updateShopUser(adminUserId: string, type: ShopUserType, name: string) {
  await post("/admin/shop/updateUser", {
    adminUserId,
    type,
    name,
  });
}

async function verifyUserStatus(userId: string, verificationCode: string) {
  const res = await get<{ email?: string; status: VerifyStatus }>(
    `/admin/verifyUserStatus?userId=${userId}&emailVerificationCode=${verificationCode}`
  );
  return res.data;
}

async function verifyUser(userId: string, emailVerificationCode: string, password: string) {
  await post("/admin/verifyUser", {
    userId,
    emailVerificationCode,
    password,
  });
}

async function resendInvitation(email: string) {
  await post("/admin/shop/resendInvitation", {
    email,
  });
}

async function removeAdminUser(adminUserId: string) {
  await post("/admin/shop/removeUser", { adminUserId });
}

async function updateOtherPassword(targetUserId: string, password: string) {
  await post("/admin/user/resetOtherPassword", {
    targetUserId,
    password,
  });
}

export async function updateCustomerPassword(customerId: string, password: string) {
  await post("/admin/user/updateCustomerPassword", {
    customerId,
    password,
  });
}

export async function getCanDoShop(cap: ShopCap) {
  const rst = await get<{ result: boolean }>(`/admin/user/canDoShop?cap=${cap}`);
  return rst.data.result;
}

const obj = { addUser, verifyUserStatus, verifyUser, resendInvitation, removeAdminUser, updateOtherPassword };
export default obj;
